import { CheckoutRouteConfig } from '/@/modules/billing/routes/CheckoutRouteConfig';
import { CheckoutRoute } from '/@/modules/billing/constants/CheckoutRoute';
import CheckoutLayout from '/@/modules/billing/pages/CheckoutLayout.vue';

export const router = [
  {
    path: CheckoutRoute.LAYOUT.path,
    name: CheckoutRoute.LAYOUT.name,
    component: CheckoutLayout,
    children: [
      CheckoutRouteConfig.factory({
        path: CheckoutRoute.CHECKOUT.path,
        name: CheckoutRoute.CHECKOUT.name,
        component: () => import('/@/modules/billing/pages/CheckoutPage.vue'),
        meta: { authOnly: false }
      }).build()
    ]
  },
  {
    path: `/${CheckoutRoute.CHECKOUT_SUCCESS.path}`,
    name: CheckoutRoute.CHECKOUT_SUCCESS.name,
    component: () => import('/@/modules/billing/pages/CheckoutInPlatformSuccessPage.vue'),
    meta: { authOnly: true }
  }
];
